import React from "react";

export default function TextMedium({ children }) {
  return <p className="text-medium">{children}</p>;
}
